

document.addEventListener('DOMContentLoaded', function () {
    const tocList = document.querySelector('#js-article-table-of-contents-list');
    const content = document.querySelector('#js-article-content');

    // 目次リストがない場合は処理を終了
    if (!tocList) {
        return;
    }

    const createTocItem = (item) => {
        const tocItem = document.createElement('li');
        tocItem.classList.add('article-table-of-contents__item');
        tocItem.innerHTML = `<a href="#${item.id}">${item.textContent}</a>`;
        return tocItem;
    }

    const updateArticleContentH2 = (content, tocList) => {
        const contentItems = content.querySelectorAll('h2');
        contentItems.forEach(item => {
            if (!item.id) {
                // IDがない場合は自動生成
                item.id = item.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-');
            }
            const tocItem = createTocItem(item);
            tocList.appendChild(tocItem);
        });
    }



    // 既存の目次アイテムをクリア（テスト用のアイテムを削除）
    tocList.innerHTML = '';

    // 記事コンテンツからh2タグを取得して目次を生成
    updateArticleContentH2(content, tocList);

    // 目次リストを表示
    tocList.style.opacity = '1';

});